<template>
  <div class="doc-type-badge">{{ label }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { docTypeLabel } from '@/models/doc'
import type { DocType } from '@/models/interfaces'

const props = defineProps<{
  docType: DocType
}>()

const label = computed(() => {
  const docType =
    props.docType === 'podcast_episode' ? 'podcast' : props.docType
  return docTypeLabel[docType].singularCap
})
</script>

<style lang="scss" scoped>
.doc-type-badge {
  position: absolute;
  z-index: 2;
  top: 12px;
  left: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba($c-white, 0.7);
  color: $c-black-3;
  font-size: 12px;
  line-height: 16px;
}

.night-mode .doc-type-badge {
  background: rgba($c-dark-1, 0.7);
  color: $c-dark-6;
}
</style>
